import { render, staticRenderFns } from "./tutor_type.vue?vue&type=template&id=1d8b5695&scoped=true&"
import script from "./tutor_type.vue?vue&type=script&lang=js&"
export * from "./tutor_type.vue?vue&type=script&lang=js&"
import style0 from "./tutor_type.vue?vue&type=style&index=0&id=1d8b5695&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b5695",
  null
  
)

export default component.exports